import type { IdDescriptionBase } from "../models/patientEncounter";

type KeysOfIdDescriptionBase = keyof IdDescriptionBase;

export const convertToComboboxModel = (
  model: IdDescriptionBase[],
  id?: string,
  valueFieldName: KeysOfIdDescriptionBase = "ViewId",
): IdDescriptionBase | undefined => {
  if (!id) {
    return undefined;
  }

  const result = model.filter((rec) => {
    const fieldValue = rec[valueFieldName];
    if (!fieldValue || typeof fieldValue !== "string") {
      return false;
    }

    return fieldValue.toUpperCase() === id.toUpperCase();
  });

  return result && result.length > 0 ? result[0] : undefined;
};

export const checkFieldForCollection = (
  id: string,
  collection: IdDescriptionBase[],
  valueField: KeysOfIdDescriptionBase = "ViewId",
): string => {
  let found = "";
  const len = collection.length;

  // check if value is valid
  if (id) {
    for (let ind = 0; ind < len; ind++) {
      const fieldValue = collection[ind][valueField];
      if (
        fieldValue &&
        typeof fieldValue === "string" &&
        fieldValue.toUpperCase() === id.toUpperCase()
      ) {
        found = fieldValue;
        break;
      }
    }
  }

  return found;
};

export const findComboValueById = (
  model: IdDescriptionBase[],
  id?: string,
  valueField: KeysOfIdDescriptionBase = "ViewId",
): string | undefined => {
  if (!id) {
    return undefined;
  }

  const len = model.length;

  for (let ind = 0; ind < len; ind++) {
    const fieldValue = model[ind][valueField];
    if (
      fieldValue &&
      typeof fieldValue === "string" &&
      fieldValue.toUpperCase() === id.toUpperCase()
    ) {
      return model[ind].title;
    }
  }

  return undefined;
};

export const findComboIdByValue = (
  model: IdDescriptionBase[],
  value?: string,
  valueField: KeysOfIdDescriptionBase = "ViewId",
): string | undefined => {
  if (!value) {
    return undefined;
  }

  const len = model.length;

  for (let ind = 0; ind < len; ind++) {
    const fieldValue = model[ind][valueField];
    if (
      fieldValue &&
      typeof fieldValue === "string" &&
      fieldValue.toUpperCase() === value.toUpperCase()
    ) {
      return fieldValue;
    }
  }

  return undefined;
};
